import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../../shared/models/paginated-result.model';
import { CreatePurchaseRequest, EntityReference, Purchase, Success, UpdatePurchaseRequest } from '../api.entities';
import { ApiService } from '../api.service';
import { PaginatedPurchaseQuery, PurchaseQuery } from './queries/purchase.query';

@Injectable({
  providedIn: 'root',
})
export class PurchasesApi extends ApiService {
  create(body: CreatePurchaseRequest): Observable<Purchase> {
    return this.request(this.client.POST('/api/purchases', { body }));
  }

  findAll(query: PaginatedPurchaseQuery): Observable<PaginatedResult<Purchase>> {
    return this.request(this.client.GET('/api/purchases', { params: { query } }));
  }

  findAllCompact(query?: PurchaseQuery): Observable<EntityReference[]> {
    return this.request(this.client.GET('/api/purchases/compact', { params: { query } }));
  }

  findOne(id: number): Observable<Purchase> {
    return this.request(this.client.GET('/api/purchases/{id}', { params: { path: { id } } }));
  }

  update(id: number, body: UpdatePurchaseRequest): Observable<Purchase> {
    return this.request(this.client.PATCH('/api/purchases/{id}', { body, params: { path: { id } } }));
  }

  deleteOne(id: number): Observable<Success> {
    return this.request(this.client.DELETE('/api/purchases/{id}', { params: { path: { id } } }));
  }
}
